import React, { useState, Suspense, useEffect, useCallback } from 'react'
import { Tabs, Spin } from 'antd'
import withDefaultLayout from '@/hoc/WithDefaultLayout'
import { CustomLoader } from '@/components/Loader'
import { useLocation, useSearchParams } from 'react-router-dom'
import ChadhavaOrders from '../ChadhavaOrders'
import SubscriptionOrders from '../SubscriptionOrders'

const PoojaOrders = React.lazy(() => import('../PoojaOrders/index'))

export const enum TAB {
    POOJA_ORDERS = 'pooja_orders',
    CHADHAVA_ORDERS = 'chadhava_orders',
    SUBSCRIPTION_ORDERS = 'subscription_orders'
}

const RefundDashboardTabs: React.FC = () => {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const type = queryParams.get('type') as string
    const [searchParams, setSearchParams] = useSearchParams()

    const [activeKey, setActiveKey] = useState<string>(type ? type : TAB.POOJA_ORDERS)

    const renderTabContent = useCallback(() => {
        switch (activeKey) {
            case TAB.POOJA_ORDERS:
                return <PoojaOrders />
            case TAB.CHADHAVA_ORDERS:
                return <ChadhavaOrders />
            case TAB.SUBSCRIPTION_ORDERS:
                return <SubscriptionOrders />
            default:
                return null
        }
    }, [activeKey])

    useEffect(() => {
        if (type) {
            setActiveKey(type)
        }
    }, [type])

    const onChange = (key: string) => {
        console.log({ key })
        setSearchParams({ type: key })
        setActiveKey(key)
    }

    return (
        <div style={{ width: '100%', padding: '0 40px', marginTop: '15px' }}>
            <div style={{ width: '100%' }}>
                <Tabs activeKey={activeKey} onChange={onChange}>
                    <Tabs.TabPane tab="Pooja Orders" key="pooja_orders">
                        <Suspense fallback={<Spin indicator={<CustomLoader />} />}>
                            {activeKey === TAB.POOJA_ORDERS && renderTabContent()}
                        </Suspense>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Chadhava Orders" key="chadhava_orders">
                        <Suspense fallback={<Spin indicator={<CustomLoader />} />}>
                            {activeKey === TAB.CHADHAVA_ORDERS && renderTabContent()}
                        </Suspense>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Subscription" key="subscription_orders">
                        <Suspense fallback={<Spin indicator={<CustomLoader />} />}>
                            {activeKey === TAB.SUBSCRIPTION_ORDERS && renderTabContent()}
                        </Suspense>
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div>
    )
}

export default withDefaultLayout(RefundDashboardTabs)